import { apiGet } from './api'

// R503 (c): the till ring's two reads, both GETs through the till's own apiGet (a 401 signs the
// till out, as every read does); the ring never writes. Their shapes are R503 (a)'s Section 0 and
// the a2 name fields, as HOP's lib/ring-api.ts reads them: GET /admin/settings (every staff role)
// and GET /admin/orders/waiting (hop, admin, kitchen, pos, viewer).

export const RING_REASONS = ['pending', 'held_card', 'kitchen_not_started', 'final_check_not_started'] as const
export type RingReason = (typeof RING_REASONS)[number]

export interface WaitingReason {
  reason: string
  ageSeconds: number
}

export interface WaitingOrder {
  id: string
  shortCode: string | null
  status: string
  reasons: WaitingReason[]
  // Dee via Rook #67688: an order is named by the person and the plate (the a2 server fields;
  // optional, a server without them omits them).
  customerName?: string | null
  items?: WaitingItem[] | null
}

export interface WaitingItem {
  nameEn: string | null
  nameAr: string | null
}

export interface WaitingAnswer {
  asOf: string
  orders: WaitingOrder[]
}

export interface SettingItem {
  key: string
  type: string
  value: unknown
  default: unknown
  bounds: unknown
  source: string
  updatedAt: string | null
}

export interface SettingsAnswer {
  entityId: string
  settings: SettingItem[]
}

export function fetchRingSettings(): Promise<SettingsAnswer> {
  return apiGet<SettingsAnswer>('/admin/settings')
}

export function fetchWaitingOrders(): Promise<WaitingAnswer> {
  return apiGet<WaitingAnswer>('/admin/orders/waiting')
}
